import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { CHART_COLORS } from '../constants';
import { formatCurrency } from '../helpers';
import styles from '../summary.module.scss';

const AXIS_TICK = { fill: '#666666', fontSize: 11, fontFamily: 'HK Grotesk' };
const CURSOR_STYLE = { fill: 'rgba(73, 163, 91, 0.06)' };

const ChartTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;
  const data = payload[0].payload;
  return (
    <div className={styles.tooltip}>
      <p className={styles.tooltipLabel}>{data.name}</p>
      <p className={styles.tooltipAmount}>{formatCurrency(data.total)}</p>
    </div>
  );
};

/**
 * Grafico de barras reutilizable para ventas.
 * layout="vertical" renderiza barras horizontales, "horizontal" (default) barras verticales.
 */
const SalesChart = ({ data, layout = 'horizontal', height = 380 }) => {
  const isVertical = layout === 'vertical';

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        layout={isVertical ? 'vertical' : undefined}
        margin={
          isVertical
            ? { top: 16, right: 16, left: 8, bottom: 16 }
            : { top: 20, right: 20, left: 10, bottom: 20 }
        }
        barCategoryGap="25%"
      >
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="#E9E7E2"
          vertical={isVertical ? false : undefined}
          horizontal={isVertical ? undefined : false}
        />

        {isVertical ? (
          <>
            <XAxis
              type="number"
              axisLine={false}
              tickLine={false}
              tick={AXIS_TICK}
              tickFormatter={(v) => `$${(v / 1000).toFixed(1)}k`}
            />
            <YAxis
              type="category"
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={AXIS_TICK}
              width={130}
            />
          </>
        ) : (
          <>
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={AXIS_TICK}
              interval={0}
              angle={-35}
              textAnchor="end"
              height={80}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={AXIS_TICK}
              tickFormatter={(v) => `$${(v / 1000).toFixed(1)}k`}
            />
          </>
        )}

        <Tooltip content={<ChartTooltip />} cursor={CURSOR_STYLE} />

        <Bar
          dataKey="total"
          radius={isVertical ? [0, 6, 6, 0] : [6, 6, 0, 0]}
          maxBarSize={isVertical ? 28 : 52}
        >
          {data.map((_, i) => (
            <Cell key={`c-${i}`} fill={CHART_COLORS[i % CHART_COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesChart;
